import { bus_hinhthuc_dangky } from '../../models/response/bus/bus_hinhthuc_dangky';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_BUS_HINHTHUC_DANGKY_PATH = "bus/hinhthuc-dangky";

class BusHinhThucDangKyApi extends BaseCRUDApi<bus_hinhthuc_dangky> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
}
export const busHinhThucDangKyApi = new BusHinhThucDangKyApi(API_BUS_HINHTHUC_DANGKY_PATH);
